import { Component,Input} from '@angular/core';
import {CdkDragDrop, transferArrayItem} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-discard',
  templateUrl: './discard.component.html',
  styleUrls: ['./discard.component.scss']
})

export class DiscardComponent {

  src="assets/img/cards/DISCARD.png";

}
